// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-overlay {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
}

.loading-overlay-spinner {
  color: white;
  text-align: center;
  display: block;
  position: absolute;
  top: 40%;
  left: 50%;
  margin: auto;
  transform: translateX(-50%);
}

.loading-overlay-text {
  position: absolute;
  text-align: center;
  width: 80%;
  left: 10%;
  top: calc(40% + 60px);
  font-size: 20px;
  color: white;
  display: block;
  font-family: roboto, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/LoadingOverlay.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC","sourcesContent":[".loading-overlay {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 9999;\n}\n\n.loading-overlay-spinner {\n  color: white;\n  text-align: center;\n  display: block;\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  margin: auto;\n  transform: translateX(-50%);\n}\n\n.loading-overlay-text {\n  position: absolute;\n  text-align: center;\n  width: 80%;\n  left: 10%;\n  top: calc(40% + 60px);\n  font-size: 20px;\n  color: white;\n  display: block;\n  font-family: roboto, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
